import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChargingStationPlacementComponent } from './charging-station-placement.component';
import CardModule from '../../../../../../component-lib/components/card/card.module';
import { DetailsModule } from '../../../../../../component-lib/components/details/details.module';
import NavTabsModule from '../../../../../../component-lib/components/nav-tabs/nav-tabs.module';
import { FormsModule } from '@angular/forms';
import CurrencyModule from '../../../../../../component-lib/components/currency/currency.module';

@NgModule({
  declarations: [ChargingStationPlacementComponent],
  exports: [ChargingStationPlacementComponent],
  imports: [CommonModule, CardModule, DetailsModule, NavTabsModule, FormsModule, CurrencyModule, TranslateModule],
})
export class ChargingStationPlacementModule {}
